import React from 'react';
import placeholderImage from '../assets/images/placeholder.png';

const PersonIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <circle cx="12" cy="12" r="12" fill="#1e293b"/>
    <circle cx="12" cy="9" r="3.5" fill="#475569"/>
    <path d="M4.5 20c0-4.142 3.358-7 7.5-7s7.5 2.858 7.5 7" stroke="#475569" strokeWidth="1.5" strokeLinecap="round" fill="none"/>
  </svg>
);

const PlayerAvatar = ({ src, alt, className }) => {
  const [failed, setFailed] = React.useState(!src);
  if (failed) return <PersonIcon className={className} />;
  return (
    <img
      src={src}
      alt={alt}
      className={className}
      onError={() => setFailed(true)}
    />
  );
};

const TeamRoster = ({ teams }) => {
  if (!teams || teams.length === 0) {
    return <div className="no-matches">No team roster information available</div>;
  }

  // Find the team objects
  const team1 = teams.find(team => team.designation === 1);
  const team2 = teams.find(team => team.designation === 2);

  return (
    <div className="team-rosters">
      {/* Team 1 Roster */}
      <div className="roster">
        <div className="roster-header">
          <img 
            src={team1?.image || placeholderImage} 
            alt={team1?.name} 
            onError={(e) => { e.target.src = placeholderImage }}
          />
          <h3>{team1?.name}</h3>
        </div>
        <div className="player-list">
          {team1?.players.map(player => (
            <div key={`${team1.id}-${player.id}`} className="player-item">
              <PlayerAvatar
                src={player.image}
                alt={player.username}
                className="player-image"
              />
              <div className="player-info">
                <div className="roster-player-handle">{player.username}</div>
                {player.name && <div className="roster-player-name">{player.name}</div>}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Team 2 Roster */}
      <div className="roster">
        <div className="roster-header">
          <img 
            src={team2?.image || placeholderImage} 
            alt={team2?.name} 
            onError={(e) => { e.target.src = placeholderImage }}
          />
          <h3>{team2?.name}</h3>
        </div>
        <div className="player-list">
          {team2?.players.map(player => (
            <div key={`${team2.id}-${player.id}`} className="player-item">
              <PlayerAvatar
                src={player.image}
                alt={player.username}
                className="player-image"
              />
              <div className="player-info">
                <div className="roster-player-handle">{player.username}</div>
                {player.name && <div className="roster-player-name">{player.name}</div>}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TeamRoster;
